import { Routes } from "@/router/Routes";
import { i18n } from "@/plugins/i18n";

const state = () => ({
  links: [
    {
      label: i18n.tc("top_nav.today"),
      href: Routes.TODAY.path,
      id: "today"
    },
    {
      label: i18n.tc("top_nav.calendar"),
      href: Routes.FAN_CALENDAR.path,
      id: "calendar"
    },
    {
      label: i18n.tc("top_nav.teams"),
      href: Routes.FAN_PLAYERS.path,
      id: "teams"
    },
    {
      label: i18n.tc("top_nav.email"),
      href: Routes.FAN_EMAIL.path,
      id: "email",
      isAlert: true
    },
    {
      label: i18n.tc("top_nav.chat"),
      href: Routes.CHAT.path,
      id: "chat"
    },
    {
      label: i18n.tc("top_nav.registration"),
      href: Routes.CREATE_REGISTRATION.path,
      id: "createRegistration"
    }
  ]
});

const getters = {
  links: (state: { links: any }) => state.links
};

export default {
  namespaced: true,
  getters,
  state
};
